import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { CssStyleListComponent } from './css-style-list.component';

@NgModule({
  declarations: [
    CssStyleListComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    McColorModule,
    MatListModule,
    MatTooltipModule
  ],
  exports: [
    CssStyleListComponent
  ]
})
export class CssStyleListModule { }
